// Import the functions you need from the SDKs you need
import { initializeApp, FirebaseApp } from "firebase/app";
import { getMessaging, getToken, onMessage, MessagePayload } from "firebase/messaging";
import { FCM_VAPID_KEY } from './env';
import { store } from '../store';
import { setFcmToken } from '../modules/fcm/actions';
import { addFcmMessage } from '../modules/fcm/reducers';
import { fetchNotifications } from '../modules/notifications/actions';

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyBcWac3bh78rnP0NBXTejnjBq7bmqjy9zA",
  authDomain: "talenthub-63435.firebaseapp.com",
  projectId: "talenthub-63435",
  storageBucket: "talenthub-63435.firebasestorage.app",
  messagingSenderId: "1029123138564",
  appId: "1:1029123138564:web:be422d135f15f543560151"
};

declare global {
  interface Window {
    firebaseConfig: typeof firebaseConfig;
  }
}

window.firebaseConfig = firebaseConfig;

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = () => {
  return getToken(messaging, { vapidKey: FCM_VAPID_KEY })
    .then((currentToken: string | null) => {
      if (currentToken) {
        console.log('current token for client: ', currentToken);
        store.dispatch(setFcmToken(currentToken));
        // Send the token to your server and update the UI if necessary
        // ...
      } else {
        // Show permission request UI
        console.log('No registration token available. Request permission to generate one.');
        // ...
      }
    })
    .catch((err: any) => {
      console.log('An error occurred while retrieving token. ', err);
      // ...
    });
};

export const onMessageListener = () =>
  console.log("onMessageListener")
  new Promise<MessagePayload>((resolve) => {
    onMessage(messaging, (payload: MessagePayload) => {
      console.log('payload', payload);
      store.dispatch(addFcmMessage(payload));
      store.dispatch(fetchNotifications({ page: 1, page_size: 10 }) as any);
      resolve(payload);
    });
  });

// Listener for messages from the service worker
if (typeof window !== 'undefined') {
  window.addEventListener('message', (event: MessageEvent) => {
    if (event.data && event.data.type === 'FCM_NOTIFICATION') {
      console.log('Received message from service worker: ', event.data.payload);
      store.dispatch(addFcmMessage(event.data.payload));
      store.dispatch(fetchNotifications({ page: 1, page_size: 10 }) as any);
    }
  });
}
